/**
 * Decision 126: the lesson events that are cards in the thread, and each card's one action. The player's is
 * Open; the coach's is Prep before the call (a Match Review with its match in), Join while the call is open,
 * Open otherwise.
 */
export const LESSON_EVENTS = new Set(['booking_confirmed', 'lesson_moved', 'time_request_accepted', 'time_adjust_accepted',
  'match_uploaded', 'lesson_finished']);

export type LessonEventAction = 'Open' | 'Prep' | 'Join';

export function lessonEventAction(p: {
  isCoach: boolean; now: number; startAt: string; windowOpenAt?: string | null; over: boolean; matchReview: boolean; hasMatch: boolean;
}): LessonEventAction {
  if (!p.isCoach || p.over) return 'Open';
  const opens = p.windowOpenAt ? Date.parse(p.windowOpenAt) : Date.parse(p.startAt) - 10 * 60_000;
  if (p.now >= opens) return 'Join';
  return p.matchReview && p.hasMatch ? 'Prep' : 'Open';
}

/**
 * A lesson event card's one line (2 Nov): what happened, the lesson's title, and its time in the reader's zone,
 * named ("Eastern Time"), in place of the server's sentence in EST. "Booked: Live Video Lesson · Match Review,
 * Tue, Nov 3 at 2:50 PM Eastern Time"; a move names who moved it when the line does.
 */
export function lessonEventLine(p: { event?: string | null; text?: string | null; title: string; when: string; zone: string }): string {
  const at = `${p.when} ${p.zone}`;
  const mover = p.event === 'lesson_moved' ? /^(.+?) moved the lesson/.exec(p.text ?? '')?.[1] : undefined;
  switch (p.event) {
    case 'booking_confirmed': return `Booked: ${p.title}, ${at}`;
    case 'lesson_moved': return mover ? `${mover} moved ${p.title} to ${at}` : `Moved: ${p.title}, ${at}`;
    case 'time_request_accepted':
    case 'time_adjust_accepted': return `New time: ${p.title}, ${at}`;
    case 'match_uploaded': return `Match uploaded: ${p.title}, ${at}`;
    case 'lesson_finished': return `Finished: ${p.title}, ${at}`;
    default: return `${p.title}, ${at}`;
  }
}
